import classnames from "classnames";

export default function Switch({
  value,
  onChange,
  label,
  ...rest
}: {
  value: boolean;
  onChange: (newValue: boolean) => void;
  label: string;
}) {
  const sz = {
    btn: "h-7 w-15",
    knob: "size-5",
    translate: ["translate-x-1", "translate-x-8"],
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={value}
      onClick={() => onChange(!value)}
      className={classnames(
        "relative inline-flex items-center flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out bg-slate-200",
        sz.btn,
      )}
      {...rest}
    >
      <span
        className={classnames(
          "absolute select-none text-xs font-semibold",
          value ? "left-2" : "right-2",
        )}
      >
        {label}
      </span>
      <span
        aria-hidden="true"
        className={classnames(
          "transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out shrink-0",
          sz.knob,
          value ? sz.translate[1] : sz.translate[0],
        )}
      />
    </button>
  );
}
